/**************************************************
 * Nombre:       TituloPeqGrande
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const TituloPeqGrande = ({peq, grande}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: sCell ? 16 : 22, fontWeight: 400}}>{peq}</Typography>
            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? -1.5 : -2.5}}>
                <Typography sx={{fontSize: sCell ? 30 : 46, fontWeight: 800}}>{grande}</Typography>
            </Grid>

        </Grid>
    )

}
export default TituloPeqGrande